export const mergeMessages = (previousMessages, newMessages, sortBy) => {
  if (previousMessages.length === 0) {
    return newMessages
  }

  const lastMessage = previousMessages[previousMessages.length - 1]
  const firstResponseMessage = newMessages[0]

  if (!firstResponseMessage || lastMessage[sortBy] !== firstResponseMessage[sortBy]) {
    // No merge needed, just append all response data
    return [...previousMessages, ...newMessages]
  }

  // Merge case: combine last message's emails with first response message's emails
  const mergedLastMessage = {
    ...lastMessage,
    emails: [...lastMessage.emails, ...firstResponseMessage.emails]
  }

  // Build new array: all previous except last + merged last + remaining response
  const newPreviousMessages = previousMessages.slice(0, -1)
  const remainingResponseData = newMessages.slice(1)

  return [...newPreviousMessages, mergedLastMessage, ...remainingResponseData]
}
